// extracted by mini-css-extract-plugin
export default {"button":"RedButton_button__i4JP6"};